const { CHANNEL_INTERFACE_TYPE, CHANNEL_INTERFACE_TEXT } = require('@/enums');
const { getSupportChannelOptions } = require('@/tools');

module.exports = () => {
  const channelOptions = getSupportChannelOptions()
    .filter(({ value }) => value !== CHANNEL_INTERFACE_TYPE.JRTT_V3);
  // 快手、网易易效不在通用渠道选项中，媒体用户管理需要单独补充
  [
    { label: CHANNEL_INTERFACE_TEXT.KUAISHOU, value: CHANNEL_INTERFACE_TYPE.KUAISHOU },
    { label: CHANNEL_INTERFACE_TEXT.YIXIAO, value: CHANNEL_INTERFACE_TYPE.YIXIAO },
  ].forEach((option) => {
    if (!channelOptions.some(({ value }) => value === option.value)) {
      channelOptions.push(option);
    }
  });

  return {
    type: {
      label: '媒体平台',
      type: 'select',
      props: {
        clearable: false,
      },
      options: channelOptions,
      value: CHANNEL_INTERFACE_TYPE.JRTT,
    },
    advertiser_id: {
      label: '广告主ID',
      type: 'input',
      value: '',
    },
  };
};

